import lenis from "../../modules/_lenis";
import rellax from "../../modules/_rellax";
import splideSetting from "./_splideSetting";

const pageRenewal = (): void => {
  // 慣性スクロールを有効化
  lenis();
  // パララックスを有効化
  rellax();
  // splideのセットアップ
  splideSetting();
};

export default pageRenewal;
